/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSessionAnalysis = /* GraphQL */ `
  mutation CreateSessionAnalysis(
    $input: CreateSessionAnalysisInput!
    $condition: ModelSessionAnalysisConditionInput
  ) {
    createSessionAnalysis(input: $input, condition: $condition) {
      id
      sessionId
      userId
      specialty
      analysisResult
      diagnoses {
        code
        description
        __typename
      }
      isSigned
      signedBy
      signedAt
      addendums {
        text
        addedBy
        addedAt
        __typename
      }
      orgUuid
      pccPatientId
      noteType
      externalId
      pushedToPCC
      pccPushAt
      timeIn
      timeOut
      durationMinutes
      isManualTimeEntry
      pccNoteId
      pccNoteStatus
      pccLastSyncedAt
      pccDeletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSessionAnalysis = /* GraphQL */ `
  mutation UpdateSessionAnalysis(
    $input: UpdateSessionAnalysisInput!
    $condition: ModelSessionAnalysisConditionInput
  ) {
    updateSessionAnalysis(input: $input, condition: $condition) {
      id
      sessionId
      userId
      specialty
      analysisResult
      diagnoses {
        code
        description
        __typename
      }
      isSigned
      signedBy
      signedAt
      addendums {
        text
        addedBy
        addedAt
        __typename
      }
      orgUuid
      pccPatientId
      noteType
      externalId
      pushedToPCC
      pccPushAt
      timeIn
      timeOut
      durationMinutes
      isManualTimeEntry
      pccNoteId
      pccNoteStatus
      pccLastSyncedAt
      pccDeletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSessionAnalysis = /* GraphQL */ `
  mutation DeleteSessionAnalysis(
    $input: DeleteSessionAnalysisInput!
    $condition: ModelSessionAnalysisConditionInput
  ) {
    deleteSessionAnalysis(input: $input, condition: $condition) {
      id
      sessionId
      userId
      specialty
      analysisResult
      diagnoses {
        code
        description
        __typename
      }
      isSigned
      signedBy
      signedAt
      addendums {
        text
        addedBy
        addedAt
        __typename
      }
      orgUuid
      pccPatientId
      noteType
      externalId
      pushedToPCC
      pccPushAt
      timeIn
      timeOut
      durationMinutes
      isManualTimeEntry
      pccNoteId
      pccNoteStatus
      pccLastSyncedAt
      pccDeletedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCodingAnalysis = /* GraphQL */ `
  mutation CreateCodingAnalysis(
    $input: CreateCodingAnalysisInput!
    $condition: ModelCodingAnalysisConditionInput
  ) {
    createCodingAnalysis(input: $input, condition: $condition) {
      id
      userId
      caseName
      patientReference
      inputDocumentKeys
      processingStatus
      resultJson
      errorJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCodingAnalysis = /* GraphQL */ `
  mutation UpdateCodingAnalysis(
    $input: UpdateCodingAnalysisInput!
    $condition: ModelCodingAnalysisConditionInput
  ) {
    updateCodingAnalysis(input: $input, condition: $condition) {
      id
      userId
      caseName
      patientReference
      inputDocumentKeys
      processingStatus
      resultJson
      errorJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCodingAnalysis = /* GraphQL */ `
  mutation DeleteCodingAnalysis(
    $input: DeleteCodingAnalysisInput!
    $condition: ModelCodingAnalysisConditionInput
  ) {
    deleteCodingAnalysis(input: $input, condition: $condition) {
      id
      userId
      caseName
      patientReference
      inputDocumentKeys
      processingStatus
      resultJson
      errorJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
